(() => {
  if (window.hsbdHeroMotionLoaded) return;
  window.hsbdHeroMotionLoaded = true;
  function initialize(root = document) {
    root.querySelectorAll('[id$="__hsbd_refined_hero"]').forEach(hero => {
      if (!hero.classList.contains('js-slideshow') || hero.dataset.hsbdMotionReady) return;
      let attempts = 0;
      function connect() {
        const slider = window.Flickity && window.Flickity.data(hero);
        if (!slider) {
          if (++attempts < 100 && hero.isConnected) setTimeout(connect, 100);
          return;
        }
        hero.dataset.hsbdMotionReady = 'true';
        const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const interval = slider.options.autoPlay;
        let manuallyStopped = false;
        function update() {
          if (preference.matches || document.hidden || hero.contains(document.activeElement) || manuallyStopped) {
            slider.stopPlayer();
          } else if (interval && !hero.matches(':hover')) {
            slider.playPlayer();
          }
        }
        function stopAfterInteraction() { manuallyStopped = true; slider.stopPlayer(); }
        hero.addEventListener('pointerdown', stopAfterInteraction);
        hero.addEventListener('keydown', event => {
          if (['ArrowLeft', 'ArrowRight', 'Enter', ' '].includes(event.key)) stopAfterInteraction();
        });
        hero.addEventListener('focusin', update);
        hero.addEventListener('focusout', () => setTimeout(update, 0));
        hero.addEventListener('mouseleave', update);
        document.addEventListener('visibilitychange', update);
        preference.addEventListener('change', update);
        slider.on('destroy', () => {
          document.removeEventListener('visibilitychange', update);
          preference.removeEventListener('change', update);
          delete hero.dataset.hsbdMotionReady;
        });
        update();
      }
      connect();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
